// extracted by mini-css-extract-plugin
module.exports = {"slideTrack":"icons_slideTrack__hwaHi","scrolls":"icons_scrolls__tvXOA","secondSlideTrack":"icons_secondSlideTrack__zVXYK","second-scroll":"icons_second-scroll__fAQXj"};